import en_GB from './en/en_GB.json';
import de_DE from './de/de_DE.json';

export default {
  en_GB,
  de_DE,
};
